import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom, timeout } from 'rxjs';
import { SessionService } from '../services/session.service';
import { VisualReportAccessService } from '../services/visual-report-access.service';
import { PosthogService } from '../services/posthog.service';
import { findFirstAccessiblePracticeTab } from '../utils/practice-tab-access.util';

export const visualReportAccessGuard: CanActivateFn = async route => {
  const session = inject(SessionService);
  const access = inject(VisualReportAccessService);
  const flags = inject(PosthogService);
  const router = inject(Router);
  if (!session.isSessionLoaded()) {
    try { await firstValueFrom(session.checkSessionStatus().pipe(timeout(8000))); }
    catch { return router.createUrlTree(['/']); }
  }
  if (access.requestAccess()) return true;
  const client = route.paramMap.get('clientId');
  const evaluation = route.paramMap.get('evaluationTypeId');
  if (client && evaluation) return router.createUrlTree(['/client', client, 'evaluation-type', evaluation]);
  const fallback = findFirstAccessiblePracticeTab(session, {
    visualReports: false,
    referenceReportAnalyzer: flags.isReferenceReportAnalyzerEnabled(),
  });
  return router.createUrlTree(fallback ? ['/settings', fallback.route] : ['/']);
};
